import { useTranslation } from 'react-i18next';
import { SlidersHorizontal, Maximize2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

interface TableToolbarProps {
  title?: string;
  enableColumnCustomization?: boolean;
  enableExport?: boolean;
  enableFullscreen?: boolean;
  onCustomizeColumns?: () => void;
  onExport?: () => void;
  onFullscreen?: () => void;
}

export function TableToolbar({
  title,
  enableColumnCustomization = true,
  enableExport = false,
  enableFullscreen = true,
  onCustomizeColumns,
  onExport,
  onFullscreen
}: TableToolbarProps) {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between items-center p-6 pb-4">
      {title && <h3 className="text-foreground text-xl font-semibold">{title}</h3>}
      <div className="flex items-center gap-2">
        {(enableColumnCustomization || enableExport) && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="h-9 w-9" data-testid="table-options-button">
                <SlidersHorizontal className="w-4 h-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              {enableColumnCustomization && (
                <DropdownMenuItem onClick={onCustomizeColumns}>
                  {t('common.customizeColumns', 'Customize Columns')}
                </DropdownMenuItem>
              )}
              {enableExport && (
                <DropdownMenuItem onClick={onExport}>{t('common.exportTable', 'Export Table')}</DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        )}

        {enableFullscreen && (
          <Button variant="outline" size="icon" className="h-9 w-9" onClick={onFullscreen}>
            <Maximize2 className="w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
